/* eslint-disable max-lines -- pure data: ~500 иконок каталога + карта их компонентов
   для резолва по имени; смысла делить произвольно на несколько файлов нет (см. отчёт
   task-3). Логика резолвинга живёт в iconCatalog.ts, и там лимит соблюдён. */
import type { LucideIcon } from 'lucide-react'

import {
  Gamepad2,
  Gamepad,
  Dices,
  Dice5,
  Sword,
  Swords,
  Joystick,
  Castle,
  Ticket,
  Shield,
  ShieldCheck,
  ShieldAlert,
  ShieldX,
  LockKeyhole,
  ScanFace,
  Siren,
  FireExtinguisher,
  LifeBuoy,
  Hammer,
  Axe,
  Drill,
  Shovel,
  Scissors,
  HardHat,
  Construction,
  Infinity as InfinityIcon,
  Asterisk,
  Equal,
  Divide,
  Sigma,
  Pi,
  Variable,
  SquareFunction,
  Copyright,
  Diamond,
  Circle,
  Square,
  Triangle,
  Hexagon,
  Shapes,
  Spade,
  Lightbulb,
  Key,
  KeyRound,
  Glasses,
  Shirt,
  Bomb,
  Lamp,
  Armchair,
  Sofa,
  DoorOpen,
  DoorClosed,
  Package,
  PackageOpen,
  Box,
  Boxes,
  Tent,
  Trash,
  Church,
  Hotel,
  Drama,
  BatteryFull,
  Layers,
  Kanban,
  TableOfContents,
  Bold,
  Italic,
  Underline,
  Type,
  AlignLeft,
  Edit,
  SquarePen,
  VolumeX,
  Gauge,
  FileText,
  File,
  Files,
  Folder,
  FolderOpen,
  Clipboard,
  ClipboardList,
  ClipboardCheck,
  FileCheck,
  FilePlus,
  FileSearch,
  FileCode,
  FileSpreadsheet,
  Paperclip,
  Newspaper,
  StickyNote,
  Archive,
  Save,
  Download,
  Upload,
  Copy,
  Trash2,
  Signature,
  Stamp,
  Image,
  Images,
  Camera,
  Video,
  Film,
  Clapperboard,
  Music,
  Music2,
  Headphones,
  Speaker,
  Volume2,
  Play,
  Pause,
  Tv,
  SquarePlay,
  SkipForward,
  Guitar,
  Piano,
  Drum,
  Palette,
  Brush,
  Paintbrush,
  PaintBucket,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  ArrowUpRight,
  ChevronRight,
  ChevronDown,
  ChevronsRight,
  Undo,
  Redo,
  RefreshCw,
  RotateCw,
  Repeat,
  Shuffle,
  Move,
  Maximize,
  Minimize,
  Milestone,
  Split,
  Merge,
  ArrowUpDown,
  ArrowLeftRight,
  Search,
  Filter,
  Menu,
  Plus,
  Minus,
  X,
  Check,
  CheckCheck,
  Home,
  LayoutGrid,
  LayoutDashboard,
  List,
  ListChecks,
  ListTodo,
  ListOrdered,
  Grid3x3,
  Table,
  Sidebar,
  Lock,
  Unlock,
  Pin,
  SlidersHorizontal,
  ToggleRight,
  Power,
  LogIn,
  LogOut,
  MoreHorizontal,
  Loader,
  CircleHelp,
  Info,
  CircleAlert,
  TriangleAlert,
  CircleCheck,
  CircleX,
  Ban,
  ZoomIn,
  ZoomOut,
  Eye,
  EyeOff,
  GraduationCap,
  BookOpen,
  Book,
  BookOpenText,
  BookOpenCheck,
  BookMarked,
  Library,
  Notebook,
  NotebookPen,
  School,
  University,
  Backpack,
  Pencil,
  PencilRuler,
  Pen,
  PenTool,
  Eraser,
  Ruler,
  Highlighter,
  Presentation,
  Projector,
  Lectern,
  ScrollText,
  Scroll,
  Languages,
  SpellCheck,
  Calculator,
  BookA,
  Blocks,
  ToyBrick,
  Puzzle,
  Quote,
  Trophy,
  Medal,
  Award,
  Crown,
  Star,
  StarHalf,
  Sparkles,
  Gem,
  Gift,
  PartyPopper,
  Ribbon,
  BadgeCheck,
  Verified,
  Flag,
  Rocket,
  Flame,
  Zap,
  ThumbsUp,
  ThumbsDown,
  Heart,
  Bookmark,
  Target,
  Atom,
  FlaskConical,
  TestTube,
  Dna,
  Brain,
  BrainCircuit,
  Magnet,
  Orbit,
  Radiation,
  Thermometer,
  Syringe,
  Pipette,
  Microscope,
  Telescope,
  Radar,
  Satellite,
  Code,
  CodeXml,
  Terminal,
  Binary,
  Braces,
  Bug,
  Cpu,
  Microchip,
  Server,
  Database,
  HardDrive,
  MemoryStick,
  Monitor,
  Laptop,
  Computer,
  Smartphone,
  Tablet,
  Keyboard,
  Mouse,
  Printer,
  Router,
  Wifi,
  Bluetooth,
  Usb,
  Plug,
  Cable,
  Bot,
  Cog,
  Settings,
  Wrench,
  Wand,
  WandSparkles,
  Network,
  Workflow,
  GitBranch,
  FolderGit2,
  Component,
  Globe,
  QrCode,
  Barcode,
  Fingerprint,
  CircuitBoard,
  Webcam,
  Cloud,
  CloudUpload,
  Rss,
  Antenna,
  Signal,
  Mail,
  MailOpen,
  Mailbox,
  Send,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Phone,
  PhoneCall,
  Megaphone,
  Speech,
  Mic,
  Bell,
  BellRing,
  AtSign,
  Hash,
  Podcast,
  Radio,
  Contact,
  Users,
  User,
  UserPlus,
  UserCheck,
  UsersRound,
  Handshake,
  Share,
  Share2,
  Link,
  ExternalLink,
  Reply,
  Forward,
  Inbox,
  Voicemail,
  DollarSign,
  Euro,
  RussianRuble,
  Coins,
  Banknote,
  CreditCard,
  Wallet,
  PiggyBank,
  Landmark,
  Building,
  Building2,
  Briefcase,
  Receipt,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  Store,
  Warehouse,
  Factory,
  Tag,
  Tags,
  Percent,
  BadgePercent,
  TrendingUp,
  TrendingDown,
  ChartBar,
  ChartLine,
  ChartPie,
  ChartColumn,
  Scale,
  HandCoins,
  Bitcoin,
  Vault,
  Gavel,
  Clock,
  Calendar,
  CalendarDays,
  CalendarCheck,
  CalendarClock,
  Timer,
  Hourglass,
  AlarmClock,
  Watch,
  History,
  Sun,
  Moon,
  CloudSun,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Snowflake,
  Wind,
  Tornado,
  Rainbow,
  Umbrella,
  Droplet,
  Droplets,
  Waves,
  Leaf,
  Trees,
  TreePine,
  TreeDeciduous,
  TreePalm,
  Flower,
  Flower2,
  Sprout,
  Wheat,
  Clover,
  Mountain,
  MountainSnow,
  Sunrise,
  Sunset,
  Earth,
  Feather,
  Bird,
  Fish,
  Cat,
  Dog,
  Rabbit,
  Turtle,
  Snail,
  Squirrel,
  PawPrint,
  Bone,
  Egg,
  Shell,
  Apple,
  Banana,
  Carrot,
  Cherry,
  Grape,
  Citrus,
  Pizza,
  Sandwich,
  Salad,
  Soup,
  Cake,
  IceCream,
  Cookie,
  Candy,
  Coffee,
  CupSoda,
  Beer,
  Wine,
  Milk,
  Utensils,
  UtensilsCrossed,
  ChefHat,
  CookingPot,
  Beef,
  Croissant,
  Donut,
  Popcorn,
  Car,
  Bus,
  Truck,
  Bike,
  Plane,
  Train,
  Ship,
  Sailboat,
  Fuel,
  Anchor,
  MapPin,
  Map,
  Navigation,
  Compass,
  Route,
  Signpost,
  TrafficCone,
  Footprints,
  Luggage,
  Tractor,
  Forklift,
  Dumbbell,
  BicepsFlexed,
  HeartPulse,
  Activity,
  Stethoscope,
  Pill,
  Bandage,
  Cross,
  HeartHandshake,
  Volleyball,
  Bed,
  Bath,
  Hospital,
  Ambulance,
  Weight,
  Smile,
  SmilePlus,
  Frown,
  Meh,
  Laugh,
  Angry,
  Annoyed,
  PersonStanding,
  Baby,
  Accessibility,
  Ghost,
  Skull,
  Ear,
  Hand,
  HandHeart,
  HandMetal,
  Grab,
  Vote,
} from 'lucide-react'

/** Иконка каталога: имя lucide (PascalCase) + краткое описание (2-3 слова) для
 *  поиска/подбора ИИ. Тип объявлен ЗДЕСЬ, а не в потребителе (`iconCatalog.ts`):
 *  импорт типа из потребителя стирается компилятором, поэтому `import/no-cycle`
 *  молчал, но модуль данных зависел от собственного фасада. */
export interface CatalogIcon {
  name: string
  description: string
}

// Каталог иконок для бейджей: имя lucide + описание (2–3 слова) для подбора ИИ и поиска.
// 500 иконок из публичных библиотек (lucide), портировано из oa-studio-prototype.
// Youtube и Github отсутствуют в установленной версии lucide-react (бренд-иконки были
// удалены из библиотеки) — заменены на смысловые эквиваленты SquarePlay и FolderGit2,
// подробности замены — в отчёте задачи.
export const ICON_CATALOG_DATA: CatalogIcon[] = [
  { name: 'Gamepad2', description: 'геймпад, игра' },
  { name: 'Gamepad', description: 'джойстик, игра' },
  { name: 'Dices', description: 'кости, игра' },
  { name: 'Dice5', description: 'кубик, случай' },
  { name: 'Sword', description: 'меч, битва' },
  { name: 'Swords', description: 'мечи, поединок' },
  { name: 'Joystick', description: 'джойстик, управление' },
  { name: 'Castle', description: 'замок, крепость' },
  { name: 'Ticket', description: 'билет, вход' },
  { name: 'Shield', description: 'щит, защита' },
  { name: 'ShieldCheck', description: 'защищено, безопасно' },
  { name: 'ShieldAlert', description: 'угроза, риск' },
  { name: 'ShieldX', description: 'блокировка, запрет' },
  { name: 'LockKeyhole', description: 'замок, скважина' },
  { name: 'ScanFace', description: 'распознавание лица' },
  { name: 'Siren', description: 'сирена, тревога' },
  { name: 'FireExtinguisher', description: 'огнетушитель' },
  { name: 'LifeBuoy', description: 'спасательный круг' },
  { name: 'Hammer', description: 'молоток, ремонт' },
  { name: 'Axe', description: 'топор' },
  { name: 'Drill', description: 'дрель, сверло' },
  { name: 'Shovel', description: 'лопата, копать' },
  { name: 'Scissors', description: 'ножницы, вырезать' },
  { name: 'HardHat', description: 'каска, строитель' },
  { name: 'Construction', description: 'стройка, работы' },
  { name: 'Infinity', description: 'бесконечность' },
  { name: 'Asterisk', description: 'звёздочка, сноска' },
  { name: 'Equal', description: 'равно, знак' },
  { name: 'Divide', description: 'деление, знак' },
  { name: 'Sigma', description: 'сумма, статистика' },
  { name: 'Pi', description: 'число пи' },
  { name: 'Variable', description: 'переменная, алгебра' },
  { name: 'SquareFunction', description: 'функция, математика' },
  { name: 'Copyright', description: 'копирайт, авторство' },
  { name: 'Diamond', description: 'ромб, фигура' },
  { name: 'Circle', description: 'круг, точка' },
  { name: 'Square', description: 'квадрат, фигура' },
  { name: 'Triangle', description: 'треугольник, фигура' },
  { name: 'Hexagon', description: 'шестиугольник, соты' },
  { name: 'Shapes', description: 'фигуры, формы' },
  { name: 'Spade', description: 'пики, карты' },
  { name: 'Lightbulb', description: 'лампочка, идея' },
  { name: 'Key', description: 'ключ, доступ' },
  { name: 'KeyRound', description: 'ключ, пароль' },
  { name: 'Glasses', description: 'очки, зрение' },
  { name: 'Shirt', description: 'футболка, одежда' },
  { name: 'Bomb', description: 'бомба, взрыв' },
  { name: 'Lamp', description: 'лампа, свет' },
  { name: 'Armchair', description: 'кресло, отдых' },
  { name: 'Sofa', description: 'диван, мебель' },
  { name: 'DoorOpen', description: 'дверь открыта' },
  { name: 'DoorClosed', description: 'дверь закрыта' },
  { name: 'Package', description: 'коробка, посылка' },
  { name: 'PackageOpen', description: 'открытая посылка' },
  { name: 'Box', description: 'коробка, ящик' },
  { name: 'Boxes', description: 'коробки, склад' },
  { name: 'Tent', description: 'палатка, кемпинг' },
  { name: 'Trash', description: 'мусор, удалить' },
  { name: 'Church', description: 'церковь, храм' },
  { name: 'Hotel', description: 'отель, гостиница' },
  { name: 'Drama', description: 'маски, театр' },
  { name: 'BatteryFull', description: 'батарея, заряд' },
  { name: 'Layers', description: 'слои, уровни' },
  { name: 'Kanban', description: 'канбан, доска' },
  { name: 'TableOfContents', description: 'оглавление, содержание' },
  { name: 'Bold', description: 'жирный текст' },
  { name: 'Italic', description: 'курсив, наклон' },
  { name: 'Underline', description: 'подчёркивание' },
  { name: 'Type', description: 'текст, шрифт' },
  { name: 'AlignLeft', description: 'выравнивание слева' },
  { name: 'Edit', description: 'редактировать, правка' },
  { name: 'SquarePen', description: 'редактировать, изменить' },
  { name: 'VolumeX', description: 'без звука, mute' },
  { name: 'Gauge', description: 'датчик, прогресс' },
  { name: 'FileText', description: 'документ, текст' },
  { name: 'File', description: 'файл' },
  { name: 'Files', description: 'файлы, документы' },
  { name: 'Folder', description: 'папка' },
  { name: 'FolderOpen', description: 'открытая папка' },
  { name: 'Clipboard', description: 'буфер обмена' },
  { name: 'ClipboardList', description: 'список, задачи' },
  { name: 'ClipboardCheck', description: 'список, проверено' },
  { name: 'FileCheck', description: 'файл проверен' },
  { name: 'FilePlus', description: 'новый файл' },
  { name: 'FileSearch', description: 'поиск файла' },
  { name: 'FileCode', description: 'файл, код' },
  { name: 'FileSpreadsheet', description: 'таблица, файл' },
  { name: 'Paperclip', description: 'скрепка, вложение' },
  { name: 'Newspaper', description: 'газета, новости' },
  { name: 'StickyNote', description: 'стикер, заметка' },
  { name: 'Archive', description: 'архив, хранение' },
  { name: 'Save', description: 'сохранить, диск' },
  { name: 'Download', description: 'скачать, загрузка' },
  { name: 'Upload', description: 'загрузить, отправить' },
  { name: 'Copy', description: 'копировать' },
  { name: 'Trash2', description: 'удалить, корзина' },
  { name: 'Signature', description: 'подпись, автограф' },
  { name: 'Stamp', description: 'печать, штамп' },
  { name: 'Image', description: 'изображение, фото' },
  { name: 'Images', description: 'галерея, фото' },
  { name: 'Camera', description: 'фотоаппарат, фото' },
  { name: 'Video', description: 'видео, ролик' },
  { name: 'Film', description: 'фильм, плёнка' },
  { name: 'Clapperboard', description: 'хлопушка, кино' },
  { name: 'Music', description: 'музыка, нота' },
  { name: 'Music2', description: 'нота, мелодия' },
  { name: 'Headphones', description: 'наушники, звук' },
  { name: 'Speaker', description: 'динамик, звук' },
  { name: 'Volume2', description: 'громкость, звук' },
  { name: 'Play', description: 'воспроизвести, старт' },
  { name: 'Pause', description: 'пауза, стоп' },
  { name: 'Tv', description: 'телевизор, экран' },
  { name: 'SquarePlay', description: 'видео, плеер' },
  { name: 'SkipForward', description: 'вперёд, пропустить' },
  { name: 'Guitar', description: 'гитара, музыка' },
  { name: 'Piano', description: 'пианино, клавиши' },
  { name: 'Drum', description: 'барабан, ритм' },
  { name: 'Palette', description: 'палитра, цвета' },
  { name: 'Brush', description: 'кисть, рисование' },
  { name: 'Paintbrush', description: 'кисть, краска' },
  { name: 'PaintBucket', description: 'ведро краски' },
  { name: 'ArrowRight', description: 'стрелка вправо' },
  { name: 'ArrowLeft', description: 'стрелка влево' },
  { name: 'ArrowUp', description: 'стрелка вверх' },
  { name: 'ArrowDown', description: 'стрелка вниз' },
  { name: 'ArrowUpRight', description: 'вверх, вправо' },
  { name: 'ChevronRight', description: 'шеврон, вправо' },
  { name: 'ChevronDown', description: 'шеврон, вниз' },
  { name: 'ChevronsRight', description: 'двойной шеврон' },
  { name: 'Undo', description: 'отменить, назад' },
  { name: 'Redo', description: 'повторить, вперёд' },
  { name: 'RefreshCw', description: 'обновить, синхронизация' },
  { name: 'RotateCw', description: 'повернуть, вращение' },
  { name: 'Repeat', description: 'повтор, цикл' },
  { name: 'Shuffle', description: 'перемешать, случайно' },
  { name: 'Move', description: 'переместить, двигать' },
  { name: 'Maximize', description: 'развернуть, полный' },
  { name: 'Minimize', description: 'свернуть, уменьшить' },
  { name: 'Milestone', description: 'веха, этап' },
  { name: 'Split', description: 'разделить, ветвление' },
  { name: 'Merge', description: 'объединить, слияние' },
  { name: 'ArrowUpDown', description: 'сортировка, вверх вниз' },
  { name: 'ArrowLeftRight', description: 'обмен, стороны' },
  { name: 'Search', description: 'поиск, лупа' },
  { name: 'Filter', description: 'фильтр, отбор' },
  { name: 'Menu', description: 'меню, список' },
  { name: 'Plus', description: 'плюс, добавить' },
  { name: 'Minus', description: 'минус, убрать' },
  { name: 'X', description: 'закрыть, крестик' },
  { name: 'Check', description: 'галочка, готово' },
  { name: 'CheckCheck', description: 'выполнено, двойная галочка' },
  { name: 'Home', description: 'дом, главная' },
  { name: 'LayoutGrid', description: 'сетка, плитки' },
  { name: 'LayoutDashboard', description: 'дашборд, панель' },
  { name: 'List', description: 'список, перечень' },
  { name: 'ListChecks', description: 'чеклист, задачи' },
  { name: 'ListTodo', description: 'задачи, дела' },
  { name: 'ListOrdered', description: 'нумерованный список' },
  { name: 'Grid3x3', description: 'сетка, ячейки' },
  { name: 'Table', description: 'таблица, данные' },
  { name: 'Sidebar', description: 'боковая панель' },
  { name: 'Lock', description: 'замок, закрыто' },
  { name: 'Unlock', description: 'разблокировать, открыто' },
  { name: 'Pin', description: 'закрепить, булавка' },
  { name: 'SlidersHorizontal', description: 'ползунки, настройки' },
  { name: 'ToggleRight', description: 'переключатель, вкл' },
  { name: 'Power', description: 'питание, вкл' },
  { name: 'LogIn', description: 'вход, войти' },
  { name: 'LogOut', description: 'выход, выйти' },
  { name: 'MoreHorizontal', description: 'ещё, меню' },
  { name: 'Loader', description: 'загрузка, ожидание' },
  { name: 'CircleHelp', description: 'помощь, вопрос' },
  { name: 'Info', description: 'информация, справка' },
  { name: 'CircleAlert', description: 'предупреждение, важно' },
  { name: 'TriangleAlert', description: 'внимание, ошибка' },
  { name: 'CircleCheck', description: 'готово, успех' },
  { name: 'CircleX', description: 'ошибка, отмена' },
  { name: 'Ban', description: 'запрет, нельзя' },
  { name: 'ZoomIn', description: 'приблизить, увеличить' },
  { name: 'ZoomOut', description: 'отдалить, уменьшить' },
  { name: 'Eye', description: 'глаз, просмотр' },
  { name: 'EyeOff', description: 'скрыть, невидимо' },
  { name: 'GraduationCap', description: 'выпускной, обучение' },
  { name: 'BookOpen', description: 'книга, чтение' },
  { name: 'Book', description: 'книга' },
  { name: 'BookOpenText', description: 'учебник, текст' },
  { name: 'BookOpenCheck', description: 'урок пройден' },
  { name: 'BookMarked', description: 'книга, закладка' },
  { name: 'Library', description: 'библиотека' },
  { name: 'Notebook', description: 'тетрадь' },
  { name: 'NotebookPen', description: 'конспект, запись' },
  { name: 'School', description: 'школа' },
  { name: 'University', description: 'университет' },
  { name: 'Backpack', description: 'рюкзак, ученик' },
  { name: 'Pencil', description: 'карандаш' },
  { name: 'PencilRuler', description: 'черчение, дизайн' },
  { name: 'Pen', description: 'ручка' },
  { name: 'PenTool', description: 'перо, инструмент' },
  { name: 'Eraser', description: 'ластик, стирание' },
  { name: 'Ruler', description: 'линейка, измерение' },
  { name: 'Highlighter', description: 'маркер, выделение' },
  { name: 'Presentation', description: 'презентация, доклад' },
  { name: 'Projector', description: 'проектор' },
  { name: 'Lectern', description: 'кафедра, лектор' },
  { name: 'ScrollText', description: 'свиток, текст' },
  { name: 'Scroll', description: 'свиток, рукопись' },
  { name: 'Languages', description: 'языки, перевод' },
  { name: 'SpellCheck', description: 'проверка орфографии' },
  { name: 'Calculator', description: 'калькулятор, расчёт' },
  { name: 'BookA', description: 'алфавит, азбука' },
  { name: 'Blocks', description: 'блоки, конструктор' },
  { name: 'ToyBrick', description: 'кубик, лего' },
  { name: 'Puzzle', description: 'пазл, головоломка' },
  { name: 'Quote', description: 'цитата, кавычки' },
  { name: 'Trophy', description: 'трофей, победа' },
  { name: 'Medal', description: 'медаль, награда' },
  { name: 'Award', description: 'награда, орден' },
  { name: 'Crown', description: 'корона, лидер' },
  { name: 'Star', description: 'звезда, рейтинг' },
  { name: 'StarHalf', description: 'половина звезды' },
  { name: 'Sparkles', description: 'блеск, волшебство' },
  { name: 'Gem', description: 'драгоценность, ценность' },
  { name: 'Gift', description: 'подарок, бонус' },
  { name: 'PartyPopper', description: 'праздник, поздравление' },
  { name: 'Ribbon', description: 'лента, награда' },
  { name: 'BadgeCheck', description: 'значок, проверено' },
  { name: 'Verified', description: 'подтверждено, галочка' },
  { name: 'Flag', description: 'флаг, цель' },
  { name: 'Rocket', description: 'ракета, старт' },
  { name: 'Flame', description: 'огонь, стрик' },
  { name: 'Zap', description: 'молния, энергия' },
  { name: 'ThumbsUp', description: 'лайк, одобрение' },
  { name: 'ThumbsDown', description: 'дизлайк, против' },
  { name: 'Heart', description: 'сердце, любовь' },
  { name: 'Bookmark', description: 'закладка, сохранить' },
  { name: 'Target', description: 'цель, мишень' },
  { name: 'Atom', description: 'атом, наука' },
  { name: 'FlaskConical', description: 'колба, химия' },
  { name: 'TestTube', description: 'пробирка, опыт' },
  { name: 'Dna', description: 'ДНК, генетика' },
  { name: 'Brain', description: 'мозг, мышление' },
  { name: 'BrainCircuit', description: 'нейросеть, мозг' },
  { name: 'Magnet', description: 'магнит, физика' },
  { name: 'Orbit', description: 'орбита, вращение' },
  { name: 'Radiation', description: 'радиация, опасность' },
  { name: 'Thermometer', description: 'термометр, температура' },
  { name: 'Syringe', description: 'шприц, укол' },
  { name: 'Pipette', description: 'пипетка, капля' },
  { name: 'Microscope', description: 'микроскоп, наука' },
  { name: 'Telescope', description: 'телескоп, астрономия' },
  { name: 'Radar', description: 'радар, сканирование' },
  { name: 'Satellite', description: 'спутник, связь' },
  { name: 'Code', description: 'код, программа' },
  { name: 'CodeXml', description: 'код, разметка' },
  { name: 'Terminal', description: 'терминал, консоль' },
  { name: 'Binary', description: 'двоичный код' },
  { name: 'Braces', description: 'фигурные скобки' },
  { name: 'Bug', description: 'баг, ошибка' },
  { name: 'Cpu', description: 'процессор, чип' },
  { name: 'Microchip', description: 'микрочип, чип' },
  { name: 'Server', description: 'сервер' },
  { name: 'Database', description: 'база данных' },
  { name: 'HardDrive', description: 'жёсткий диск' },
  { name: 'MemoryStick', description: 'память, флешка' },
  { name: 'Monitor', description: 'монитор, экран' },
  { name: 'Laptop', description: 'ноутбук' },
  { name: 'Computer', description: 'компьютер' },
  { name: 'Smartphone', description: 'смартфон, телефон' },
  { name: 'Tablet', description: 'планшет' },
  { name: 'Keyboard', description: 'клавиатура' },
  { name: 'Mouse', description: 'компьютерная мышь' },
  { name: 'Printer', description: 'принтер, печать' },
  { name: 'Router', description: 'роутер, сеть' },
  { name: 'Wifi', description: 'вайфай, интернет' },
  { name: 'Bluetooth', description: 'блютус, связь' },
  { name: 'Usb', description: 'usb, разъём' },
  { name: 'Plug', description: 'розетка, питание' },
  { name: 'Cable', description: 'кабель, провод' },
  { name: 'Bot', description: 'робот, бот' },
  { name: 'Cog', description: 'шестерёнка, механизм' },
  { name: 'Settings', description: 'настройки, параметры' },
  { name: 'Wrench', description: 'гаечный ключ' },
  { name: 'Wand', description: 'волшебная палочка' },
  { name: 'WandSparkles', description: 'магия, ИИ' },
  { name: 'Network', description: 'сеть, узлы' },
  { name: 'Workflow', description: 'процесс, схема' },
  { name: 'GitBranch', description: 'ветка, git' },
  { name: 'FolderGit2', description: 'гитхаб, репозиторий' },
  { name: 'Component', description: 'компонент, деталь' },
  { name: 'Globe', description: 'глобус, интернет' },
  { name: 'QrCode', description: 'qr код' },
  { name: 'Barcode', description: 'штрихкод' },
  { name: 'Fingerprint', description: 'отпечаток пальца' },
  { name: 'CircuitBoard', description: 'плата, схема' },
  { name: 'Webcam', description: 'веб камера' },
  { name: 'Cloud', description: 'облако, хранилище' },
  { name: 'CloudUpload', description: 'загрузка в облако' },
  { name: 'Rss', description: 'подписка, rss' },
  { name: 'Antenna', description: 'антенна, сигнал' },
  { name: 'Signal', description: 'сигнал, связь' },
  { name: 'Mail', description: 'почта, письмо' },
  { name: 'MailOpen', description: 'открытое письмо' },
  { name: 'Mailbox', description: 'почтовый ящик' },
  { name: 'Send', description: 'отправить, послать' },
  { name: 'MessageCircle', description: 'сообщение, чат' },
  { name: 'MessageSquare', description: 'чат, диалог' },
  { name: 'MessagesSquare', description: 'переписка, беседа' },
  { name: 'Phone', description: 'телефон, звонок' },
  { name: 'PhoneCall', description: 'входящий звонок' },
  { name: 'Megaphone', description: 'рупор, объявление' },
  { name: 'Speech', description: 'речь, произношение' },
  { name: 'Mic', description: 'микрофон, запись' },
  { name: 'Bell', description: 'колокольчик, уведомление' },
  { name: 'BellRing', description: 'звонок, оповещение' },
  { name: 'AtSign', description: 'собака, email' },
  { name: 'Hash', description: 'решётка, хэштег' },
  { name: 'Podcast', description: 'подкаст, эфир' },
  { name: 'Radio', description: 'радио, эфир' },
  { name: 'Contact', description: 'контакт, карточка' },
  { name: 'Users', description: 'пользователи, группа' },
  { name: 'User', description: 'пользователь, профиль' },
  { name: 'UserPlus', description: 'добавить друга' },
  { name: 'UserCheck', description: 'пользователь подтверждён' },
  { name: 'UsersRound', description: 'команда, люди' },
  { name: 'Handshake', description: 'рукопожатие, сделка' },
  { name: 'Share', description: 'поделиться, отправить' },
  { name: 'Share2', description: 'поделиться, сеть' },
  { name: 'Link', description: 'ссылка, связь' },
  { name: 'ExternalLink', description: 'внешняя ссылка' },
  { name: 'Reply', description: 'ответить, реплай' },
  { name: 'Forward', description: 'переслать, вперёд' },
  { name: 'Inbox', description: 'входящие, ящик' },
  { name: 'Voicemail', description: 'голосовое сообщение' },
  { name: 'DollarSign', description: 'доллар, деньги' },
  { name: 'Euro', description: 'евро, валюта' },
  { name: 'RussianRuble', description: 'рубль, валюта' },
  { name: 'Coins', description: 'монеты, деньги' },
  { name: 'Banknote', description: 'банкнота, купюра' },
  { name: 'CreditCard', description: 'карта, оплата' },
  { name: 'Wallet', description: 'кошелёк, деньги' },
  { name: 'PiggyBank', description: 'копилка, накопления' },
  { name: 'Landmark', description: 'банк, учреждение' },
  { name: 'Building', description: 'здание, офис' },
  { name: 'Building2', description: 'офис, компания' },
  { name: 'Briefcase', description: 'портфель, работа' },
  { name: 'Receipt', description: 'чек, квитанция' },
  { name: 'ShoppingCart', description: 'корзина покупок' },
  { name: 'ShoppingBag', description: 'сумка, покупки' },
  { name: 'ShoppingBasket', description: 'корзина, товары' },
  { name: 'Store', description: 'магазин, лавка' },
  { name: 'Warehouse', description: 'склад, хранение' },
  { name: 'Factory', description: 'завод, производство' },
  { name: 'Tag', description: 'ярлык, цена' },
  { name: 'Tags', description: 'теги, метки' },
  { name: 'Percent', description: 'процент, скидка' },
  { name: 'BadgePercent', description: 'скидка, акция' },
  { name: 'TrendingUp', description: 'рост, график' },
  { name: 'TrendingDown', description: 'падение, спад' },
  { name: 'ChartBar', description: 'график, столбцы' },
  { name: 'ChartLine', description: 'график, линия' },
  { name: 'ChartPie', description: 'круговая диаграмма' },
  { name: 'ChartColumn', description: 'гистограмма, данные' },
  { name: 'Scale', description: 'весы, баланс' },
  { name: 'HandCoins', description: 'выплата, деньги' },
  { name: 'Bitcoin', description: 'биткоин, крипта' },
  { name: 'Vault', description: 'сейф, хранилище' },
  { name: 'Gavel', description: 'молоток, аукцион' },
  { name: 'Clock', description: 'часы, время' },
  { name: 'Calendar', description: 'календарь, дата' },
  { name: 'CalendarDays', description: 'календарь, дни' },
  { name: 'CalendarCheck', description: 'дата отмечена' },
  { name: 'CalendarClock', description: 'расписание, срок' },
  { name: 'Timer', description: 'таймер, обратный отсчёт' },
  { name: 'Hourglass', description: 'песочные часы' },
  { name: 'AlarmClock', description: 'будильник' },
  { name: 'Watch', description: 'наручные часы' },
  { name: 'History', description: 'история, прошлое' },
  { name: 'Sun', description: 'солнце, день' },
  { name: 'Moon', description: 'луна, ночь' },
  { name: 'CloudSun', description: 'переменная облачность' },
  { name: 'CloudRain', description: 'дождь' },
  { name: 'CloudSnow', description: 'снег' },
  { name: 'CloudLightning', description: 'гроза, молния' },
  { name: 'Snowflake', description: 'снежинка, холод' },
  { name: 'Wind', description: 'ветер' },
  { name: 'Tornado', description: 'торнадо, буря' },
  { name: 'Rainbow', description: 'радуга' },
  { name: 'Umbrella', description: 'зонт, дождь' },
  { name: 'Droplet', description: 'капля, вода' },
  { name: 'Droplets', description: 'капли, влага' },
  { name: 'Waves', description: 'волны, море' },
  { name: 'Leaf', description: 'лист, природа' },
  { name: 'Trees', description: 'деревья, лес' },
  { name: 'TreePine', description: 'ель, хвоя' },
  { name: 'TreeDeciduous', description: 'дерево, крона' },
  { name: 'TreePalm', description: 'пальма, тропики' },
  { name: 'Flower', description: 'цветок' },
  { name: 'Flower2', description: 'цветок, бутон' },
  { name: 'Sprout', description: 'росток, рост' },
  { name: 'Wheat', description: 'пшеница, урожай' },
  { name: 'Clover', description: 'клевер, удача' },
  { name: 'Mountain', description: 'гора, вершина' },
  { name: 'MountainSnow', description: 'снежная гора' },
  { name: 'Sunrise', description: 'рассвет, утро' },
  { name: 'Sunset', description: 'закат, вечер' },
  { name: 'Earth', description: 'земля, планета' },
  { name: 'Feather', description: 'перо, лёгкость' },
  { name: 'Bird', description: 'птица' },
  { name: 'Fish', description: 'рыба' },
  { name: 'Cat', description: 'кошка' },
  { name: 'Dog', description: 'собака' },
  { name: 'Rabbit', description: 'кролик, заяц' },
  { name: 'Turtle', description: 'черепаха, медленно' },
  { name: 'Snail', description: 'улитка, медленно' },
  { name: 'Squirrel', description: 'белка' },
  { name: 'PawPrint', description: 'лапа, животное' },
  { name: 'Bone', description: 'кость' },
  { name: 'Egg', description: 'яйцо' },
  { name: 'Shell', description: 'ракушка, море' },
  { name: 'Apple', description: 'яблоко, фрукт' },
  { name: 'Banana', description: 'банан' },
  { name: 'Carrot', description: 'морковь, овощ' },
  { name: 'Cherry', description: 'вишня, ягода' },
  { name: 'Grape', description: 'виноград' },
  { name: 'Citrus', description: 'цитрус, лимон' },
  { name: 'Pizza', description: 'пицца' },
  { name: 'Sandwich', description: 'сэндвич, бутерброд' },
  { name: 'Salad', description: 'салат, здоровье' },
  { name: 'Soup', description: 'суп' },
  { name: 'Cake', description: 'торт, праздник' },
  { name: 'IceCream', description: 'мороженое' },
  { name: 'Cookie', description: 'печенье, куки' },
  { name: 'Candy', description: 'конфета, сладость' },
  { name: 'Coffee', description: 'кофе, напиток' },
  { name: 'CupSoda', description: 'напиток, стакан' },
  { name: 'Beer', description: 'пиво' },
  { name: 'Wine', description: 'вино, бокал' },
  { name: 'Milk', description: 'молоко' },
  { name: 'Utensils', description: 'приборы, еда' },
  { name: 'UtensilsCrossed', description: 'ресторан, кухня' },
  { name: 'ChefHat', description: 'повар, кулинария' },
  { name: 'CookingPot', description: 'кастрюля, готовка' },
  { name: 'Beef', description: 'мясо, стейк' },
  { name: 'Croissant', description: 'круассан, выпечка' },
  { name: 'Donut', description: 'пончик, десерт' },
  { name: 'Popcorn', description: 'попкорн, кино' },
  { name: 'Car', description: 'автомобиль, машина' },
  { name: 'Bus', description: 'автобус' },
  { name: 'Truck', description: 'грузовик, доставка' },
  { name: 'Bike', description: 'велосипед' },
  { name: 'Plane', description: 'самолёт, перелёт' },
  { name: 'Train', description: 'поезд' },
  { name: 'Ship', description: 'корабль, судно' },
  { name: 'Sailboat', description: 'парусник, лодка' },
  { name: 'Fuel', description: 'заправка, топливо' },
  { name: 'Anchor', description: 'якорь, море' },
  { name: 'MapPin', description: 'метка, место' },
  { name: 'Map', description: 'карта, маршрут' },
  { name: 'Navigation', description: 'навигация, направление' },
  { name: 'Compass', description: 'компас, ориентир' },
  { name: 'Route', description: 'маршрут, путь' },
  { name: 'Signpost', description: 'указатель, направление' },
  { name: 'TrafficCone', description: 'конус, дорога' },
  { name: 'Footprints', description: 'следы, шаги' },
  { name: 'Luggage', description: 'багаж, чемодан' },
  { name: 'Tractor', description: 'трактор, ферма' },
  { name: 'Forklift', description: 'погрузчик, склад' },
  { name: 'Dumbbell', description: 'гантель, фитнес' },
  { name: 'BicepsFlexed', description: 'мышцы, сила' },
  { name: 'HeartPulse', description: 'пульс, здоровье' },
  { name: 'Activity', description: 'активность, пульс' },
  { name: 'Stethoscope', description: 'стетоскоп, врач' },
  { name: 'Pill', description: 'таблетка, лекарство' },
  { name: 'Bandage', description: 'пластырь, рана' },
  { name: 'Cross', description: 'крест, медицина' },
  { name: 'HeartHandshake', description: 'забота, поддержка' },
  { name: 'Volleyball', description: 'волейбол, мяч' },
  { name: 'Bed', description: 'кровать, отдых' },
  { name: 'Bath', description: 'ванна, гигиена' },
  { name: 'Hospital', description: 'больница' },
  { name: 'Ambulance', description: 'скорая помощь' },
  { name: 'Weight', description: 'вес, гиря' },
  { name: 'Smile', description: 'улыбка, радость' },
  { name: 'SmilePlus', description: 'добавить эмоцию' },
  { name: 'Frown', description: 'грусть, недовольство' },
  { name: 'Meh', description: 'равнодушие, скука' },
  { name: 'Laugh', description: 'смех, веселье' },
  { name: 'Angry', description: 'злость, гнев' },
  { name: 'Annoyed', description: 'раздражение' },
  { name: 'PersonStanding', description: 'человек, фигура' },
  { name: 'Baby', description: 'ребёнок, малыш' },
  { name: 'Accessibility', description: 'доступность, инвалид' },
  { name: 'Ghost', description: 'призрак, привидение' },
  { name: 'Skull', description: 'череп, опасность' },
  { name: 'Ear', description: 'ухо, слух' },
  { name: 'Hand', description: 'рука, ладонь' },
  { name: 'HandHeart', description: 'забота, доброта' },
  { name: 'HandMetal', description: 'рок, жест' },
  { name: 'Grab', description: 'схватить, рука' },
  { name: 'Vote', description: 'голосование, выбор' },
]

// Реестр компонентов только для иконок каталога — резолвим по PascalCase-имени.
// Собран из явных именованных импортов (см. выше), а не через
// `import * as Lucide from 'lucide-react'`, чтобы бандлер мог tree-shake
// неиспользуемые иконки библиотеки (см. отчёт task-3, раздел про bundle size).
export const ICON_REGISTRY: Record<string, LucideIcon> = {
  Gamepad2,
  Gamepad,
  Dices,
  Dice5,
  Sword,
  Swords,
  Joystick,
  Castle,
  Ticket,
  Shield,
  ShieldCheck,
  ShieldAlert,
  ShieldX,
  LockKeyhole,
  ScanFace,
  Siren,
  FireExtinguisher,
  LifeBuoy,
  Hammer,
  Axe,
  Drill,
  Shovel,
  Scissors,
  HardHat,
  Construction,
  Infinity: InfinityIcon,
  Asterisk,
  Equal,
  Divide,
  Sigma,
  Pi,
  Variable,
  SquareFunction,
  Copyright,
  Diamond,
  Circle,
  Square,
  Triangle,
  Hexagon,
  Shapes,
  Spade,
  Lightbulb,
  Key,
  KeyRound,
  Glasses,
  Shirt,
  Bomb,
  Lamp,
  Armchair,
  Sofa,
  DoorOpen,
  DoorClosed,
  Package,
  PackageOpen,
  Box,
  Boxes,
  Tent,
  Trash,
  Church,
  Hotel,
  Drama,
  BatteryFull,
  Layers,
  Kanban,
  TableOfContents,
  Bold,
  Italic,
  Underline,
  Type,
  AlignLeft,
  Edit,
  SquarePen,
  VolumeX,
  Gauge,
  FileText,
  File,
  Files,
  Folder,
  FolderOpen,
  Clipboard,
  ClipboardList,
  ClipboardCheck,
  FileCheck,
  FilePlus,
  FileSearch,
  FileCode,
  FileSpreadsheet,
  Paperclip,
  Newspaper,
  StickyNote,
  Archive,
  Save,
  Download,
  Upload,
  Copy,
  Trash2,
  Signature,
  Stamp,
  Image,
  Images,
  Camera,
  Video,
  Film,
  Clapperboard,
  Music,
  Music2,
  Headphones,
  Speaker,
  Volume2,
  Play,
  Pause,
  Tv,
  SquarePlay,
  SkipForward,
  Guitar,
  Piano,
  Drum,
  Palette,
  Brush,
  Paintbrush,
  PaintBucket,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  ArrowUpRight,
  ChevronRight,
  ChevronDown,
  ChevronsRight,
  Undo,
  Redo,
  RefreshCw,
  RotateCw,
  Repeat,
  Shuffle,
  Move,
  Maximize,
  Minimize,
  Milestone,
  Split,
  Merge,
  ArrowUpDown,
  ArrowLeftRight,
  Search,
  Filter,
  Menu,
  Plus,
  Minus,
  X,
  Check,
  CheckCheck,
  Home,
  LayoutGrid,
  LayoutDashboard,
  List,
  ListChecks,
  ListTodo,
  ListOrdered,
  Grid3x3,
  Table,
  Sidebar,
  Lock,
  Unlock,
  Pin,
  SlidersHorizontal,
  ToggleRight,
  Power,
  LogIn,
  LogOut,
  MoreHorizontal,
  Loader,
  CircleHelp,
  Info,
  CircleAlert,
  TriangleAlert,
  CircleCheck,
  CircleX,
  Ban,
  ZoomIn,
  ZoomOut,
  Eye,
  EyeOff,
  GraduationCap,
  BookOpen,
  Book,
  BookOpenText,
  BookOpenCheck,
  BookMarked,
  Library,
  Notebook,
  NotebookPen,
  School,
  University,
  Backpack,
  Pencil,
  PencilRuler,
  Pen,
  PenTool,
  Eraser,
  Ruler,
  Highlighter,
  Presentation,
  Projector,
  Lectern,
  ScrollText,
  Scroll,
  Languages,
  SpellCheck,
  Calculator,
  BookA,
  Blocks,
  ToyBrick,
  Puzzle,
  Quote,
  Trophy,
  Medal,
  Award,
  Crown,
  Star,
  StarHalf,
  Sparkles,
  Gem,
  Gift,
  PartyPopper,
  Ribbon,
  BadgeCheck,
  Verified,
  Flag,
  Rocket,
  Flame,
  Zap,
  ThumbsUp,
  ThumbsDown,
  Heart,
  Bookmark,
  Target,
  Atom,
  FlaskConical,
  TestTube,
  Dna,
  Brain,
  BrainCircuit,
  Magnet,
  Orbit,
  Radiation,
  Thermometer,
  Syringe,
  Pipette,
  Microscope,
  Telescope,
  Radar,
  Satellite,
  Code,
  CodeXml,
  Terminal,
  Binary,
  Braces,
  Bug,
  Cpu,
  Microchip,
  Server,
  Database,
  HardDrive,
  MemoryStick,
  Monitor,
  Laptop,
  Computer,
  Smartphone,
  Tablet,
  Keyboard,
  Mouse,
  Printer,
  Router,
  Wifi,
  Bluetooth,
  Usb,
  Plug,
  Cable,
  Bot,
  Cog,
  Settings,
  Wrench,
  Wand,
  WandSparkles,
  Network,
  Workflow,
  GitBranch,
  FolderGit2,
  Component,
  Globe,
  QrCode,
  Barcode,
  Fingerprint,
  CircuitBoard,
  Webcam,
  Cloud,
  CloudUpload,
  Rss,
  Antenna,
  Signal,
  Mail,
  MailOpen,
  Mailbox,
  Send,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Phone,
  PhoneCall,
  Megaphone,
  Speech,
  Mic,
  Bell,
  BellRing,
  AtSign,
  Hash,
  Podcast,
  Radio,
  Contact,
  Users,
  User,
  UserPlus,
  UserCheck,
  UsersRound,
  Handshake,
  Share,
  Share2,
  Link,
  ExternalLink,
  Reply,
  Forward,
  Inbox,
  Voicemail,
  DollarSign,
  Euro,
  RussianRuble,
  Coins,
  Banknote,
  CreditCard,
  Wallet,
  PiggyBank,
  Landmark,
  Building,
  Building2,
  Briefcase,
  Receipt,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  Store,
  Warehouse,
  Factory,
  Tag,
  Tags,
  Percent,
  BadgePercent,
  TrendingUp,
  TrendingDown,
  ChartBar,
  ChartLine,
  ChartPie,
  ChartColumn,
  Scale,
  HandCoins,
  Bitcoin,
  Vault,
  Gavel,
  Clock,
  Calendar,
  CalendarDays,
  CalendarCheck,
  CalendarClock,
  Timer,
  Hourglass,
  AlarmClock,
  Watch,
  History,
  Sun,
  Moon,
  CloudSun,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Snowflake,
  Wind,
  Tornado,
  Rainbow,
  Umbrella,
  Droplet,
  Droplets,
  Waves,
  Leaf,
  Trees,
  TreePine,
  TreeDeciduous,
  TreePalm,
  Flower,
  Flower2,
  Sprout,
  Wheat,
  Clover,
  Mountain,
  MountainSnow,
  Sunrise,
  Sunset,
  Earth,
  Feather,
  Bird,
  Fish,
  Cat,
  Dog,
  Rabbit,
  Turtle,
  Snail,
  Squirrel,
  PawPrint,
  Bone,
  Egg,
  Shell,
  Apple,
  Banana,
  Carrot,
  Cherry,
  Grape,
  Citrus,
  Pizza,
  Sandwich,
  Salad,
  Soup,
  Cake,
  IceCream,
  Cookie,
  Candy,
  Coffee,
  CupSoda,
  Beer,
  Wine,
  Milk,
  Utensils,
  UtensilsCrossed,
  ChefHat,
  CookingPot,
  Beef,
  Croissant,
  Donut,
  Popcorn,
  Car,
  Bus,
  Truck,
  Bike,
  Plane,
  Train,
  Ship,
  Sailboat,
  Fuel,
  Anchor,
  MapPin,
  Map,
  Navigation,
  Compass,
  Route,
  Signpost,
  TrafficCone,
  Footprints,
  Luggage,
  Tractor,
  Forklift,
  Dumbbell,
  BicepsFlexed,
  HeartPulse,
  Activity,
  Stethoscope,
  Pill,
  Bandage,
  Cross,
  HeartHandshake,
  Volleyball,
  Bed,
  Bath,
  Hospital,
  Ambulance,
  Weight,
  Smile,
  SmilePlus,
  Frown,
  Meh,
  Laugh,
  Angry,
  Annoyed,
  PersonStanding,
  Baby,
  Accessibility,
  Ghost,
  Skull,
  Ear,
  Hand,
  HandHeart,
  HandMetal,
  Grab,
  Vote,
}
